export enum ToastType {
  WARNING,
  ERROR,
  SUCCESS,
  INFO,
  ACTION
}
